import { Card, CardContent, Typography, Box } from '@mui/material'
import { themeColors } from '../../app/layout/theme'

interface StatCardProps {
  title: string
  value: string | number
  icon?: React.ReactNode
  color?: string
  bgcolor?: string
  gradient?: string
  trend?: { value: number; label: string }
  subtitle?: string   // plain-text line shown below value (no arrow/%)
}

export const StatCard = ({
  title,
  value,
  icon,
  color = themeColors.primary,
  bgcolor = '#ffffff',
  trend,
  subtitle,
}: StatCardProps) => {
  return (
    <Card
      sx={{
        background: bgcolor,
        borderRadius: '12px',
        border: `1px solid ${themeColors.border}`,
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        overflow: 'hidden',
        position: 'relative',
        height: '100%',
        width: 'auto',
        transition: 'all 0.2s ease',
        '&:hover': {
          transform: 'translateY(-0.5px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
          borderColor: themeColors.primary,
        },
      }}
    >
      <CardContent sx={{ p: '16px 20px !important', position: 'relative', zIndex: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {icon && (
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '8px',
                  backgroundColor: `${color}12`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '& svg': { fontSize: 18, color: color },
                }}
              >
                {icon}
              </Box>
            )}
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 500,
                color: themeColors.text.primary,
                letterSpacing: '0.5px',
              }}
            >
              {title}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Typography
              title={String(value)}
              sx={{
                fontSize: '18px',
                fontWeight: 700,
                color: themeColors.text.primary,
                lineHeight: 1,
                letterSpacing: '-0.5px',
              }}
            >
              {value}
            </Typography>
            
            {trend && (
              <Typography sx={{
                fontSize: '11px',
                color: trend.value >= 0 ? themeColors.success : themeColors.error,
                fontWeight: 600,
                mt: 0.5
              }}>
                {trend.value >= 0 ? '↑' : '↓'} {Math.abs(trend.value)}% {trend.label}
              </Typography>
            )}
            {subtitle && !trend && (
              <Typography sx={{ fontSize: '11px', color: themeColors.text.secondary, fontWeight: 500, mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
